import React from 'react';
import Script from 'next/script';
import { ListProps, SchemaProps } from '@/components/schema/types';

const extractPlainText = (description: any): string => {
  if (Array.isArray(description)) {
    return description
      .map((block) =>
        block.children?.map((child: { text: string }) => child.text).join(' '),
      )
      .join(' ');
  }
  return '';
};

const SchemaComponent: React.FC<SchemaProps> = ({ items }) => {
  if (!items) return null;

  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: items.map((faq: ListProps) => ({
      '@type': 'Question',
      name: faq.title,
      acceptedAnswer: {
        '@type': 'Answer',
        text: extractPlainText(faq.description),
      },
    })),
  };

  return (
    <Script
      type="application/ld+json"
      id="faq-schema"
      strategy="afterInteractive"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }}
    />
  );
};

export default SchemaComponent;
